import { useState, useEffect } from "react";

export default function Navbar() {
    const [navActive, setNavActive] = useState(false);
    const [activeItem, setActiveItem] = useState("home");
    const [showHamburger, setShowHamburger] = useState(false);

    const toggleNav = () =>{
        setShowHamburger(!showHamburger);
        setNavActive(!navActive);
    }

    const closeMenu = () =>{
        setNavActive(false);
    }

    useEffect(() =>{
        const handleResize = () =>{
            if(window.innerWidth <= 500){
                closeMenu();
            }
        }

        window.addEventListener("resize", handleResize);
        var timer = null;
        const handleScroll = (e) =>{
            if(timer !== null) {
                clearTimeout(timer);        
            }
            timer = setTimeout(function() {
                var pos = window.scrollY;
                var pos2 = pos + 50;
                var heroSection = document.getElementById("home");
                var skills = document.getElementById("skills");
                var experience = document.getElementById("experience");
                var contact = document.getElementById("contact");
                if(pos2 > contact.offsetTop){
                    setActiveItem('contact');
                }
                else if(pos2 > experience.offsetTop){
                    setActiveItem('experience');
                }
                else if(pos2 > skills.offsetTop){
                    setActiveItem('skills');
                }
                else if(pos2 > heroSection.offsetTop){
                    setActiveItem('home');
                }
            }, 30);
        }
        window.addEventListener("scroll", handleScroll, { passive: true });
        return () =>{
            window.removeEventListener("scroll", handleScroll, { passive: true });
            window.removeEventListener("resize", handleResize);
        }

    }, []);

    useEffect(() =>{
        if(window.innerWidth <= 1200){
            closeMenu();
        }
        setNavActive(window.innerWidth >= 960 ? true : false);
        setShowHamburger(window.innerWidth >= 960 ? true : false);
        setActiveItem('home');
        
    },[]);

    return (
        <>
        <nav className={`navbar ${navActive ? 'active' : ''}`}>
            <div className="navbar--logo--container">
                <div>
                    <img className="navbar--profile--pic" src="https://karthick-profile.s3.ap-south-1.amazonaws.com/profile-pic.jpeg" alt="Logo"/>
                </div>
                <span>KARTHICK JAYAKUMAR</span>
            </div>
            <button
                type="button"
                className={`nav__hamburger ${showHamburger ? 'active' : ''}`}
                onClick={toggleNav}
                aria-label="Toggle navigation menu"
            >
                <span className="nav__hamburger__line"/>
                <span className="nav__hamburger__line"/>
                <span className="nav__hamburger__line"/>
            </button>
            <div className={`navbar--items ${navActive ? 'active visible':'invisible'}`}>
                <ul>
                    <li key={1}>
                        <a onClick={() => setActiveItem('home')}
                            activeclass="heroSection" 
                            spy="true"
                            smooth="true"
                            offset={-70}
                            duration={500}
                            href="#home"
                            className={`navbar--content ${activeItem === 'home' ? 'active' : ''}`}>
                            HOME
                        </a>
                    </li> 
                    <li key={2}>
                        <a onClick={() => setActiveItem('skills')}
                            activeclass="skills" 
                            spy="true"
                            smooth="true"
                            offset={-70}
                            duration={500}
                            href="#skills"
                            className={`navbar--content ${activeItem === 'skills' ? 'active' : ''}`}>
                            SKILLS
                        </a>
                    </li>
                    <li key={3}>
                        <a onClick={() => setActiveItem('experience')}
                            activeclass="experience" 
                            spy="true"
                            smooth="true"
                            offset={-70}
                            duration={500}
                            href="#experience"
                            className={`navbar--content ${activeItem === 'experience' ? 'active' : ''}`}>
                            EXPERIENCE
                        </a>
                    </li>
                    <li key={4}>
                        <a onClick={() => setActiveItem('contact')}
                            activeclass="contact" 
                            spy="true"
                            smooth="true"
                            offset={-70}
                            duration={500}
                            href="#contact"
                            className={`navbar--content ${activeItem === 'contact' ? 'active' : ''}`}>
                            CONTACT
                        </a>
                    </li>
                </ul>
            </div>
        </nav>
        </>
    )
}